import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const KEY = "trent_cookie_consent_v1";

export default function CookieConsent() {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    try { if (!localStorage.getItem(KEY)) setOpen(true); } catch { /* ignore */ }
  }, []);
  if (!open) return null;

  const accept = () => {
    try { localStorage.setItem(KEY, "accepted"); } catch { /* ignore */ }
    setOpen(false);
  };
  const decline = () => {
    try { localStorage.setItem(KEY, "declined"); } catch { /* ignore */ }
    setOpen(false);
  };

  return (
    <div
      className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:w-[420px] bg-white border border-[#E5E7EB] rounded-lg shadow-xl p-5 z-50"
      data-testid="cookie-banner"
      role="dialog"
      aria-live="polite"
    >
      <div className="text-[10px] uppercase tracking-[0.25em] text-[#16A34A] font-bold mb-2">
        Cookies & data
      </div>
      <p className="text-sm text-[#0F172A] leading-snug">
        We use strictly-necessary cookies to keep you signed in. No tracking or analytics
        cookies are set without your consent. See our{" "}
        <Link to="/privacy" className="underline text-[#0F172A] font-semibold">Privacy Policy</Link>.
      </p>
      <div className="flex justify-end gap-2 mt-4">
        <button onClick={decline} className="trent-btn-secondary" data-testid="cookie-decline">
          Decline
        </button>
        <button onClick={accept} className="trent-btn-primary" data-testid="cookie-accept">
          Accept
        </button>
      </div>
    </div>
  );
}
